import React from "react";
import { translate } from "../../common/localization";
import "./index.css";

const termsAndConditions = () => (
  <div className="terms-and-conditions">
    <p dangerouslySetInnerHTML={{__html: translate('termsAndConditions')}}></p>
  </div>
);

export default termsAndConditions;
